<mat-toolbar class="navbar mat-typography" color="primary">
    <mat-toolbar-row>
        <div class="copyright center">Copyright &copy; Tempo Technologies</div>
        <a class="right" href="mailto:Tempo%20Technologies%3Csupport%40tempotech.com%3E?subject=SmartPart%20Support%20Request"
           mat-button>Support</a>
    </mat-toolbar-row>
</mat-toolbar>
